var Curriculog = Curriculog || {};

Curriculog.Committees = (function ($, _, Backbone, Committees) {

	Committees = Curriculog.CurriculogCollection.extend({
		url: '/rest/committee',
		model: Curriculog.Committee,

		comparator: function (a, b) {
			if (a.get('name').toLowerCase() < b.get('name').toLowerCase())
				return -1;
			if (a.get('name').toLowerCase() > b.get('name').toLowerCase())
				return 1;
			else return 0;
		},
	});
	return Committees;

})($, _, Backbone, Curriculog.Committees || {});